const BRIGHTNESS_WEIGHTS = {
  red: 299,
  green: 587,
  blue: 114,
} as const;

const BRIGHTNESS_DIVISOR = 1000;
const LIGHT_BACKGROUND_THRESHOLD = 186;

export const getTextColorByBackground = (hexColor: string): string => {
  const hex = hexColor.replace('#', '');

  const r = Number.parseInt(hex.slice(0, 2), 16);
  const g = Number.parseInt(hex.slice(2, 4), 16);
  const b = Number.parseInt(hex.slice(4, 6), 16);

  const brightness = (
    r * BRIGHTNESS_WEIGHTS.red +
    g * BRIGHTNESS_WEIGHTS.green +
    b * BRIGHTNESS_WEIGHTS.blue
  ) / BRIGHTNESS_DIVISOR;

  return brightness > LIGHT_BACKGROUND_THRESHOLD
    ? '#000000'
    : '#FFFFFF';
};
